module.exports = __webpack_public_path__ + "static/img/zhongjiang.png";